import { convertRadiansToDegrees } from '@paragon/geometry-library';

export const formatForce = (pounds: number) => {
  const roundedValue = Math.round(pounds);
  const plural = roundedValue !== 1;
  return `${roundedValue} lb${plural ? 's' : ''}`;
};
export const formatMoment = (poundInches: number) => `${Math.round(poundInches)} lb-in.`;
export const formatDistributedForce = (poundsPerLinearFoot: number) => `${poundsPerLinearFoot.toFixed(1)} plf`;
export const formatDegrees = (degrees: number) => `${degrees.toFixed(2)}°`;
export const formatRadiansAsDegrees = (radians: number) => formatDegrees(convertRadiansToDegrees(radians));
